import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import { ButtonGroup } from "../ButtonGroup";
import { Button } from "../Button";
import { NAVIGATION_GROUP_MAX_SIZE_DEFAULT, ELLIPSIS_INDEX } from "./consts";
export function PageNavigationGroup(props) {
  var lastPage = props.lastPage,
    goToPage = props.goToPage,
    currentPage = props.currentPage;
  var assignNavButtonTargets = useCallback(function () {
    var navButtonTargets = [];
    var numElements = NAVIGATION_GROUP_MAX_SIZE_DEFAULT;
    if (lastPage <= numElements) numElements = lastPage;
    var ellipsisIndex = ELLIPSIS_INDEX;
    for (var i = 0; i < numElements; i++) {
      if (numElements == lastPage) {
        navButtonTargets.push(i + 1);
        continue;
      }
      if (i === ellipsisIndex) {
        navButtonTargets.push(null);
      } else if (i < ellipsisIndex) {
        navButtonTargets.push(i + 1);
      } else {
        navButtonTargets.push(lastPage - (numElements - 1) + i);
      }
    }
    return navButtonTargets;
  }, [lastPage]);
  var navigationButtons = useCallback(function () {
    // determine how many elements to have and what elements will have which targets
    var navButtonTargets = assignNavButtonTargets();
    return navButtonTargets.map(function (targetAssignment, index) {
      var target = targetAssignment;
      var onClick = function onClick() {
        goToPage(target);
      };
      if (target === null) {
        target = '...';
        onClick = null;
      }
      return /*#__PURE__*/React.createElement(Button, {
        key: index,
        color: "secondary",
        variant: "outlined",
        disabled: target === currentPage,
        onClick: onClick
      }, target);
    });
  }, [assignNavButtonTargets, goToPage, currentPage]);
  return /*#__PURE__*/React.createElement(ButtonGroup, null, navigationButtons());
}